import CustomButton from 'components/Buttons/CustomButton'
import { Plus } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardText, Col, Row } from 'reactstrap'
import { addItem } from '../purchaseCommoditySlice'
import Item from './Item'

const ItemInfo = ({ isProductionUnit }) => {
  const dispatch = useDispatch()
  const { addItemCount } = useSelector((state) => state.purchaseCommmodity)

  if (isProductionUnit) {
    return (
      <div>
        {addItemCount?.map((num, idx) => (
          <div key={idx} data-testid={`purchase-form-item-row-${idx}`}>
            <Item isProductionUnit={isProductionUnit} key={idx} fieldNum={num} idx={idx} />
          </div>
        ))}

        <CardBody className="p-0">
          <CustomButton
            size="sm"
            style={{ maxWidth: 186 }}
            className="ml-2"
            color="primary"
            outline
            testId="purchase-form-add-item-button"
            onClick={() => {
              dispatch(addItem())
            }}
          >
            <Plus size={16} />
            <span>Tambah Barang</span>
          </CustomButton>
        </CardBody>
      </div>
    )
  } else {
    return (
      <Card body className="custom-container m-0 m-auto border-0 shadow-sm">
        <Row>
          <Col>
            <Card className="border-0">
              <CardText tag="h5">Barang Yang Dibeli</CardText>
              {addItemCount?.map((num, idx) => (
                <div key={idx} data-testid={`purchase-form-item-row-${idx}`}>
                  <Item key={idx} fieldNum={num} idx={idx} />
                </div>
              ))}

              <CardBody className="py-0">
                <CustomButton
                  size="sm"
                  style={{ maxWidth: 186 }}
                  className="ml-2"
                  color="primary"
                  outline
                  testId="purchase-form-add-item-button"
                  onClick={() => {
                    dispatch(addItem())
                  }}
                >
                  <Plus size={16} />
                  <span>Tambah Barang</span>
                </CustomButton>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Card>
    )
  }
}

export default ItemInfo
